
export class UploadFile {
    constructor(
        public relativePath: string,
        public fileEntry: any) {
    }
}


// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ngx-file-drop/lib/ngx-drop/upload-file.model.ts